import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/inquiries"



export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};


export const Details = async (values) => {
  return await axiosInstance(options).post(`${path}/details`, values);  
};

export const resolveInquiry = async (values) => {
  return await axiosInstance(options).post(`${path}/mark-resolve`, values);  
};

export const Delete = async (values) => {
  return await axiosInstance(options).post(`${path}/delete`, values);  
};

export const ChangeStatus = async (values) => {
  return await axiosInstance(options).post(`${path}/change-status`, values);  
};

export const GetNewCount = async () => {
  return await axiosInstance(options).get(`${path}/new-count`);
};







